import apiClient from './base/apiClient'

export interface SearchHistoryItem {
  keyword: string
  timestamp: number
}

export interface GetSearchHistoryResponse {
  items: SearchHistoryItem[]
}

export const searchHistoryApi = {
  getList: async (): Promise<GetSearchHistoryResponse> => {
    const response = await apiClient.get<GetSearchHistoryResponse>(
      '/search-history'
    )
    return response.data
  },

  add: async (keyword: string): Promise<void> => {
    await apiClient.post('/search-history', { keyword: keyword.trim() })
  },

  remove: async (keyword: string): Promise<void> => {
    await apiClient.delete('/search-history', {
      params: { keyword },
    })
  },

  clear: async (): Promise<void> => {
    await apiClient.delete('/search-history/clear')
  },
}
